<template>
  <v-select
    label="Ethnicity"
    v-model="profile.ethnicity"
    :loading="loading"
    @input="submit"
    :items="ethnicities"
    :color="themes.candidate.light.input"
    :menu-props="{ offsetY: true }"
    attach
  />
</template>

<script>
// Data
import ethnicities from '@/data/ethnicities'

// Vue Component
export default {
  props: ['value'],
  data() {
    return {
      ethnicities,
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        ethnicity: this.value,
      },
    }
  },
  methods: {
    submit() {
      if (this.value !== this.profile.ethnicity) {
        this.loading = true
        this.$store
          .dispatch('candidate/profile/update', this.profile)
          .then(() => (this.loading = false))
      }
    },
  },
}
</script>
